import ServiciosGeneral from "./ServiciosGeneral";
import servicios from "./serviciosSolicitudes";

const serviciosTablero = {
  getTablero: ServiciosGeneral.llamarServidorRespuesta("Tablero/get"),
  crearTablero: ServiciosGeneral.llamarServidorRespuesta("Tablero/create"),
  updateTablero: ServiciosGeneral.llamarServidorRespuesta("Tablero/update"),
  archivarTablero: ServiciosGeneral.llamarServidorRespuesta("Tablero/archivarTablero"),
  getCtlsTablero: ServiciosGeneral.llamarServidorRespuestaPost("Tablero/getCtlsTablero"),
  getParticipantesTablero: ServiciosGeneral.llamarServidorRespuestaPost("Tablero/getParticipantesTablero"),
  insertParticipantesTablero: ServiciosGeneral.llamarServidorRespuesta("Tablero/insertParticipantesTablero"),
  ordernarTablero: ServiciosGeneral.llamarServidorRespuestaPost("Tablero/ordernarTablero"),
  getCtlsFiltros: ServiciosGeneral.llamarServidorRespuesta("Tablero/getCtlsFiltros"),
  getHistorialMovimientos: ServiciosGeneral.llamarServidorRespuesta("Tablero/getHistorialMovimientos"),
  getTablerosArchivados: ServiciosGeneral.llamarServidorRespuesta("Tablero/getTablerosArchivados"),
  getTableros:ServiciosGeneral.llamarServidorRespuesta("Tablero/getTableros"),
  //Etapa
  crearEtapa: ServiciosGeneral.llamarServidorRespuesta("Etapa/create"),
  updateEtapaInfo: ServiciosGeneral.llamarServidorRespuesta("Etapa/update"),
  eliminarEtapa: ServiciosGeneral.llamarServidorRespuesta("Etapa/destroy"),
  //tarjeta
  crearTarjeta: ServiciosGeneral.llamarServidorRespuesta("Tarjeta/create"),
  updateTituloTarjeta: ServiciosGeneral.llamarServidorRespuesta("Tarjeta/updateTitulo"),
  archivarTarjeta: ServiciosGeneral.llamarServidorRespuesta("Tarjeta/archivarTarjeta"),
  getMiembrosDisponiblesTarjeta:ServiciosGeneral.llamarServidorRespuestaPost("Tarjeta/getMiembrosDisponibles"),
  agregarMiembroTarjeta:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/agregarMiembro"),
  eliminarMiembro:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/eliminarMiembro"),
  getTarjetasArchivados:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getTarjetasArchivados"),
  getTarjetas:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getTarjetas"),
  getTarjetasFechas:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getTarjetasFechas"),
  //Miembros
  verMiembros:ServiciosGeneral.llamarServidorRespuesta("Miembros/getAllMembers"),
  getTarjetaMiembros:ServiciosGeneral.llamarServidorRespuesta("Miembros/getAllTarjetaMembers"),
  getTableroMiembros:ServiciosGeneral.llamarServidorRespuesta("Tablero/getAllMembers"),
  updateMiembroTablero:ServiciosGeneral.llamarServidorRespuesta("Miembros/updateMiembroTablero"),
  eliminarParticipantesTablero: ServiciosGeneral.llamarServidorRespuesta("Miembros/removerMiembroTablero"),
  
  //Descripcion
  addDescripcion:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/addDescripcion"),
  deleteDescripcion:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/deleteDescripcion"),
  getDescripcion:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getDescripcion"),
  //Comentarios
  verComentarios:ServiciosGeneral.llamarServidorRespuesta("Comentario/get"),
  agregarComentarios:ServiciosGeneral.llamarServidorRespuesta("Comentario/create"),
  editarComentarios:ServiciosGeneral.llamarServidorRespuesta("Comentario/edit"),
  eliminarComentarios:ServiciosGeneral.llamarServidorRespuesta("Comentario/delete"),
  //Checklist
  getChecklist:ServiciosGeneral.llamarServidorRespuesta("ListaTareas/get"),
  addChecklist:ServiciosGeneral.llamarServidorRespuesta("ListaTareas/add"),
  editChecklist:ServiciosGeneral.llamarServidorRespuesta("ListaTareas/edit"),
  deleteChecklist:ServiciosGeneral.llamarServidorRespuesta("ListaTareas/delete"),

  //TARJETA SOLICITUD
  getSolicitudesTarjeta:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getSolicitudes"),
  asignarSolicitudTarjeta:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/setSolicitudTarjeta"),
  getTarjetaData:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getTarjetaData"),
  //ETIQUETAS
  

  getEtiqueta:ServiciosGeneral.llamarServidorRespuesta("Etiqueta/get"),
  addEtiqueta:ServiciosGeneral.llamarServidorRespuesta("Etiqueta/add"),
  editEtiqueta:ServiciosGeneral.llamarServidorRespuesta("Etiqueta/edit"),
  deleteEtiqueta:ServiciosGeneral.llamarServidorRespuesta("Etiqueta/delete"),


  getEtiquetaTarjeta:ServiciosGeneral.llamarServidorRespuesta("EtiquetaTarjeta/get"),
  addEtiquetaTarjeta:ServiciosGeneral.llamarServidorRespuesta("EtiquetaTarjeta/add"),
  deleteEtiquetaTarjeta:ServiciosGeneral.llamarServidorRespuesta("EtiquetaTarjeta/delete"),
  //Tareas
  getTareas:ServiciosGeneral.llamarServidorRespuesta("Tarea/get"),
  addTarea:ServiciosGeneral.llamarServidorRespuesta("Tarea/add"),
  editTarea:ServiciosGeneral.llamarServidorRespuesta("Tarea/edit"),
  deleteTarea:ServiciosGeneral.llamarServidorRespuesta("Tarea/delete"),
  updateTareaStatus:ServiciosGeneral.llamarServidorRespuesta("Tarea/editStatus"),
  //Fechas
  updateTituloTarjeta: ServiciosGeneral.llamarServidorRespuesta(
    "Tarjeta/updateTitulo"
  ),
  getMotivosFechas:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getMotivos"),
  getSolicitudesPendientesFechas:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getSolicitudesPendientesFechas"),
  getHistorialCambiosFechas:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getHistorialCambiosFechas"),
  createSolicitudCambioFecha:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/createSolicitudCambioFecha"),
  cambiarEstatusSolicitud:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/cambiarEstatusSolicitudCambioFecha"),
  


  // INFORMACION PARA LOS MODALES DE LOS ADMIN
  getInformacionGeneral:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getInformacionGeneral"),
  getDocumentacionSolicitud:ServiciosGeneral.llamarServidorRespuesta("Tarjeta/getArchivosSolicitud"),
  // INICIA DOCUMENTACIÓN.
  getDocumentation: ServiciosGeneral.llamarServidorRespuesta(
    "Tablero/getDocumentation"
  ),
  getFolders: ServiciosGeneral.llamarServidorRespuesta("Tablero/getFolders"),
  createFolder: ServiciosGeneral.llamarServidorRespuesta(
    "Tablero/createFolder"
  ),
  updateFolder: ServiciosGeneral.llamarServidorRespuesta(
    "Tablero/updateFolder"
  ),
  createFile: ServiciosGeneral.llamarServidorRespuesta("Tablero/createFile"),
  updateFile: ServiciosGeneral.llamarServidorRespuesta("Tablero/updateFile"),
  // TERMINAN SERVICIOS DE DOCUMENTACIÓN

  //DOCUMENTACION POR TARJETA
  getDocumentationTarjeta: ServiciosGeneral.llamarServidorRespuesta(
    "Tarjeta/getArchivos"
  ),
  createFileTarjeta: ServiciosGeneral.llamarServidorRespuesta("Tarjeta/createFile"),
  updateFileTarjeta: ServiciosGeneral.llamarServidorRespuesta("Tarjeta/updateFile")

};
export default serviciosTablero;
